"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetAllQuestConfigsForUserSortToJSON = exports.GetAllQuestConfigsForUserSortFromJSONTyped = exports.GetAllQuestConfigsForUserSortFromJSON = exports.GetAllQuestConfigsForUserSort = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var GetAllQuestConfigsForUserSort;
(function (GetAllQuestConfigsForUserSort) {
    GetAllQuestConfigsForUserSort["CreatedAt"] = "createdAt";
    GetAllQuestConfigsForUserSort["Name"] = "name";
})(GetAllQuestConfigsForUserSort = exports.GetAllQuestConfigsForUserSort || (exports.GetAllQuestConfigsForUserSort = {}));
function GetAllQuestConfigsForUserSortFromJSON(json) {
    return GetAllQuestConfigsForUserSortFromJSONTyped(json, false);
}
exports.GetAllQuestConfigsForUserSortFromJSON = GetAllQuestConfigsForUserSortFromJSON;
function GetAllQuestConfigsForUserSortFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.GetAllQuestConfigsForUserSortFromJSONTyped = GetAllQuestConfigsForUserSortFromJSONTyped;
function GetAllQuestConfigsForUserSortToJSON(value) {
    return value;
}
exports.GetAllQuestConfigsForUserSortToJSON = GetAllQuestConfigsForUserSortToJSON;
